import digital from "../../../../assets/img/Partnerships/digital.jpg";

import {
  MdOutlineDashboardCustomize,
} from 'react-icons/md';
import { BsShieldCheck } from 'react-icons/bs';
import { BsDatabaseUp } from 'react-icons/bs';

export default function Section4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={digital}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Client-Centric Solutions
            </h1>
            <p className="text-lg text-gray-600">
              Our collaboration with Alibaba Cloud allows us to offer:
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineDashboardCustomize className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Customized Digital Transformation Strategies
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                We design solutions that align with your specific business
                objectives, leveraging the combined strengths of AeroAegis and
                Alibaba Cloud.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BsShieldCheck className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Enhanced Security and Compliance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Utilizing Alibaba Cloud's robust security protocols, we ensure
                your data is protected and compliant with industry standards.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BsDatabaseUp className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Scalable and Cost-Effective Services
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Our partnership enables us to provide flexible solutions that
                grow with your business, optimizing costs without compromising
                quality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
{
  /* <div>
      <div>
        <section className="dark:bg-gray-800 pt-5 dark:text-gray-100">
          <div className="container flex flex-col place-items-center mx-auto lg:flex-row">
            <div className="lg:w-1/2 xl:w-3/5 dark:bg-gray-800">
              <div className="flex items-center justify-center p-4 md:p-8 lg:p-12">
                <img
                  src='' 
                  alt=""
                  className="rounded-lg shadow-lg dark:bg-gray-500 object-cover h-80 sm:min-h-96"
                />
              </div>
            </div>
            <div className="flex flex-col px-6 py-8 space-y-6 rounded-sm sm:p-8 lg:p-12 lg:w-1/2 xl:w-2/5 bg-[#23307F] text-white dark:text-gray-900">
              <h3 className="text-2xl font-bold tracki sm:text-3xl dark:text-gray-50">
                Client-Centric Solutions
              </h3>
              <p className="text-lg font-medium leading">
                Our collaboration with Alibaba Cloud allows us to offer:
              </p>
              <div className="flex space-x-2 sm:space-x-4 pt-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="flex-shrink-0 w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  ></path>
                </svg>
                <div className="space-y-2">
                  <p className="text-lg font-medium leading">
                    <b>Customized Digital Transformation Strategies: </b> We
                    design solutions that align with your specific business
                    objectives, leveraging the combined strengths of AeroAegis
                    and Alibaba Cloud.
                  </p>
                </div>
              </div>

              <div className="flex space-x-2 sm:space-x-4 pt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="flex-shrink-0 w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  ></path>
                </svg>
                <div className="space-y-2">
                  <p className="text-lg font-medium leading">
                    <b>Enhanced Security and Compliance: </b> Utilizing Alibaba
                    Cloud's robust security protocols, we ensure your data is
                    protected and compliant with industry standards.
                  </p>
                </div>
              </div>
              <div className="flex space-x-2 sm:space-x-4 pt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="flex-shrink-0 w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                  ></path>
                </svg>
                <div className="space-y-2">
                  <p className="text-lg font-medium leading">
                    <b>Scalable and Cost-Effective Services: </b> Our
                    partnership enables us to provide flexible solutions that
                    grow with your business, optimizing costs without
                    compromising quality.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div> */
}
